import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import AOS from "aos";

import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/global.css";
import "aos/dist/aos.css";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

AOS.init();
